module.exports = __webpack_public_path__ + "media/question1_en.4133c064.mp3";